import { render, staticRenderFns } from "./TheAdminFooter.vue?vue&type=template&id=3257274a"
import script from "./TheAdminFooter.vue?vue&type=script&lang=js"
export * from "./TheAdminFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports